import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import classNames from 'classnames';

import { Spinner } from '@ps-design-system/components/Spinner';
import XIcon from '@ps-design-system/icons/X/X24';
import PendingIcon from '@ps-design-system/icons/Pending/Pending24';

import { formatBytes } from '../../../utils/utils';

const AttachmentPreview = ({ state, remove, retry, Icon, name, size, imageSrc, intl = {} }) => {
  const showLoader = useMemo(() => {
    return 'uploading' === state;
  }, [state]);

  const isFailed = useMemo(() => {
    return 'failed' === state;
  }, [state]);

  const displaySize = useMemo(() => formatBytes(size, intl), [size, intl.locale]);

  return (
    <div className={classNames('AttachmentPreview border relative', { 'image-preview': imageSrc, 'padding-md': !imageSrc })}>
      {imageSrc
        ? <img className="image" src={imageSrc} alt={name} />
        : <div className="flex">
          {Icon && <Icon height={24} width={24} className="margin-md-right attachment-preview-icon" />}
          <div className="attachment-preview-file-info full-width">
            {name && <div className="ellipsis text-small text-gray-900">{name}</div>}
            {size && <div className="text-xs text-gray-600">{displaySize}</div>}
          </div>
        </div>
      }
      <div className="control-container absolute">
        {showLoader
          ? <Spinner className="preview-spinner" />
          : isFailed
            ? <button
              className="str-chat__attachment-preview-delete retry-button"
              type="button"
              onClick={retry}
            >
              <PendingIcon height={16} width={16} className="retry-icon" />
            </button>
            : <button
              className="str-chat__attachment-preview-delete delete-button"
              type="button"
              onClick={remove}
            >
              <XIcon height={16} width={16} className="delete-icon" />
            </button>
        }
      </div>
    </div>
  );
};

AttachmentPreview.propTypes = {
  state: PropTypes.string,
  remove: PropTypes.func,
  retry: PropTypes.func,
  Icon: PropTypes.element,
  name: PropTypes.string,
  size: PropTypes.number,
  imageSrc: PropTypes.string,
  intl: intlShape
};

exports.AttachmentPreview = injectIntl(AttachmentPreview);
